import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
export function App() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: MetaPixelFunction = ((...args: unknown[]) => {
      if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
    }) as MetaPixelFunction;
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(pixelScript);
    fbq('init', '1785580659491412');
    fbq('track', 'PageView');
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="38o4ercumih4r">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1785580659491412&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="3dkl4ucldv5kh" />
      </noscript>
      <div className="min-h-screen bg-brand-blush text-brand-charcoal overflow-x-hidden flex flex-col items-center" data-id="element-2" data-mp="studdqo0mp7y">
        <div className="w-full max-w-3xl bg-brand-ivory shadow-2xl" data-id="element-3" data-mp="356s95xbri9l">
          <UrgencyBanner data-id="element-4" data-mp="3udax89lkcp58" />
          <Hero data-id="element-5" data-mp="3ubzumd3utnfp" />
          <PainSection data-id="element-6" data-mp="3ucjcjtti8btq" />
          <SolutionSection data-id="element-7" data-mp="3uf5lnxw1mze2" />
          <LookInside data-id="element-8" data-mp="d57d4waue6fw" />
          <BonusSection data-id="element-9" data-mp="d3cvprys4wgk" />
          <PricingCard data-id="element-10" data-mp="d2l9h7r2ob2y" />
          <Guarantee data-id="element-11" data-mp="85l1granwy97" />
          <Testimonials data-id="element-12" data-mp="85bbh3pmar3i" />
          <FAQ data-id="element-13" data-mp="86w3omoglxy7" />
          <FinalCTA data-id="element-14" data-mp="86cld4uwd7jn" />
          <Footer data-id="element-15" data-mp="83qdf443gq0w" />
        </div>
      </div>
    </>;
}